import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnChanges } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { IconConfiguration } from '../icon-configuration';

@Component({
  selector: 'icon-content',
  templateUrl: './icon-content.html',
  styleUrls: ['./icon-content.less'],
  imports: [MatIconModule, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconContent implements OnChanges {
  public configuration = input<IconConfiguration>();
  public iconStyle = input();

  protected iconName: string;

  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  public ngOnChanges(): void {
    if (!this.configuration()?.icon) {
      return;
    }

    let iconUrl = this.configuration().icon;
    this.iconName = this.configuration().icon;

    if (!iconUrl.includes('/')) {
      // if there is no slash in the icon name, add default path as url
      iconUrl = `icons/${this.configuration().icon}.svg`;
    } else {
      // split by ":", if there are is more than 1 part, remove everything except the last one (this essentially means that we do not support icons with
      // "namespaces" - except if they are in the default path of the app...)
      const parts = this.configuration().icon.split(':');
      this.iconName = parts.length > 1 ? parts[parts.length - 1] : this.configuration().icon;
    }

    const sanitizedIconPath = this.sanitizer.bypassSecurityTrustResourceUrl(iconUrl);

    this.iconRegistry.getNamedSvgIcon(this.iconName).subscribe({ error: () => this.iconRegistry.addSvgIcon(this.iconName, sanitizedIconPath) });
  }
}
